/* eslint-disable camelcase */
import React from 'react';
import {
  cancelButton, save, Text, FilterGroup,
} from '../../app-components';
import { ROUTES, selectActiveOrInactiveStatus } from '../../Lib/constants';
import DealerData from './DealerData';
import SuperDealerData from './SuperDealerData';
import AllDealerDataForEmployee from './AllDealerDataForEmployee';
import EditDealer from './EditDealer';
import ViewDealer from './ViewDealer';
import ViewSubDealer from './ViewSubDealer';
import EditDealerKyc from './EditDealerKyc';
import ViewDealerKyc from './ViewDealerKyc';
import vars from '../../theme/vars';
import FtsSearch from '../../Components/TableFilters/FtsSearch';
import { filterLogo, edit_icon } from '../../images';
import { autoSuggestOptionsFilter } from '../../autoSuggestions';
import { IconButton } from '../../app-components/buttons/Buttons';
import SetupDealerAccountForm from './SetupDealerAccount/SetupDealerAccountForm';
import { addIcon } from '../../images';
import AddDealer from './AddDealer';

const { headings } = vars;



export default {
  [ROUTES.dealerData.name]: {
    screen: DealerData,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>
        Manage Dealers
      </Text>
    ),

   
    headerActions: [
      {
        render: () => (
          <IconButton
            description="Add Dealer"
            tooltipId="add-dealer"
            icon={addIcon}
            label="Add Dealer"
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
          />
        ),
        type: 'link',
        link: () => ({
          view: 'addDealer',
          push: true,
          expanded: true,
        }),
      },

      (props) => (
        <FtsSearch
          {...props}
          placeholder="Search by email/Name/Phone"
          action={{
            exp: ['name', 'email', 'phonenumber'],
          }}
        />
      ),

      FilterGroup({
        icon: filterLogo,
        activeIcon: filterLogo,
        appliedIcon: filterLogo,
        imageStyle: { width: 24, height: 24 },
        filters: [
          autoSuggestOptionsFilter({
            field: 'activityStatus',
            label: 'Status',
            valueField: 'label',
            options: selectActiveOrInactiveStatus,
          }),
        ],
      }),
    ],
  },


  [ROUTES.superDealerData.name]: {
    screen: SuperDealerData,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>
        Manage Sub-Dealers
      </Text>
    ),

   
    headerActions: [


      (props) => (
        <FtsSearch
          {...props}
          placeholder="Search by email/Name/Phone"
          action={{
            exp: ['name', 'email', 'phonenumber'],
          }}
        />
      ),

      FilterGroup({
        icon: filterLogo,
        activeIcon: filterLogo,
        appliedIcon: filterLogo,
        imageStyle: { width: 24, height: 24 },
        filters: [
          autoSuggestOptionsFilter({
            field: 'activityStatus',
            label: 'Status',
            valueField: 'label',
            options: selectActiveOrInactiveStatus,
          }),
        ],
      }),
    ],
  },

  [ROUTES.allDealerData.name]: {
    screen: AllDealerDataForEmployee,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>
        All Dealers
      </Text>
    ),

   
    headerActions: [


      (props) => (
        <FtsSearch
          {...props}
          placeholder="Search by email/Name/Phone"
          action={{
            exp: ['name', 'email', 'phonenumber'],
          }}
        />
      ),

      FilterGroup({
        icon: filterLogo,
        activeIcon: filterLogo,
        appliedIcon: filterLogo,
        imageStyle: { width: 24, height: 24 },
        filters: [
          autoSuggestOptionsFilter({
            field: 'activityStatus',
            label: 'Status',
            valueField: 'label',
            options: selectActiveOrInactiveStatus,
          }),
        ],
      }),
    ],
  },

  ['addDealer']: {
    screen: AddDealer,
    expanded: true,
    headerActions: [cancelButton],

  },


  [ROUTES.editDealer.name]: {
    screen: EditDealer,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Edit</Text>
    ),
    headerActions: [cancelButton, save],
  },

  [ROUTES.ViewDealer.name]: {
    screen: ViewDealer,
    screenProps: {
      editable: false,
      type: 'standard',
      visible: false,
      fromView: true,
    },
    expanded: true,
  },

  [ROUTES.ViewSubDealer.name]: {
    screen: ViewSubDealer,
    screenProps: {
      editable: false,
      type: 'standard',
      visible: false,
      fromView: true,
    },
    expanded: true,
  },

  [ROUTES.editDealerKyc.name]: {
    screen: EditDealerKyc,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Edit KYC</Text>
    ),
    headerActions: [cancelButton, save],
  },

  [ROUTES.ViewDealerKyc.name]: {
    screen: ViewDealerKyc,
    screenProps: {
      editable: false,
      type: 'standard',
      visible: false,
      fromView: true,
    },
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>
        Dealer KYC
      </Text>
    ),
    headerActions: [
      cancelButton,
      {
        render: () => (
          <IconButton
            tooltipId="dealer-kyc"
            icon={edit_icon}
            description="Edit KYC"
            label="Edit Dealer"
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
          />
        ),
        type: 'link',
        link: (props) => ({
          view: ROUTES.editDealerKyc.name,
          params: {
            item: { ...props?.navigation?.state?.params.item },
          },
        }),
      },
    ],
  },

  [ROUTES.setupDealerAccount.name]: {
    screen: SetupDealerAccountForm,
    expanded: true,
    title: () => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>
        Setup Dealer&#39;s Account
      </Text>
    ),
    headerActions: [save],
  },
};
